module.exports = __webpack_public_path__ + "src/assets/img/garanty_card2.f8280e38.jpg";